import type { FindingPublishedFilter } from '../store/tab/findingsTabScopedFilterStore';

export function resolveFindingsPublishedApiFilter(
  publishedFilter: FindingPublishedFilter,
): {
  isPublished?: boolean;
  wasAutoPublished?: boolean;
} {
  if (publishedFilter === 'ALL') {
    return {};
  }

  if (publishedFilter === 'published') {
    return { isPublished: true };
  }

  if (publishedFilter === 'unpublished') {
    return { isPublished: false };
  }

  return { isPublished: true, wasAutoPublished: true };
}

export function resolveFindingsPublishedBadgeLabel({
  isPublished,
  wasAutoPublished,
  labels,
}: {
  isPublished: boolean;
  wasAutoPublished?: boolean;
  labels: {
    unpublished: string;
    published: string;
    autoPublished: string;
  };
}): string {
  if (!isPublished) {
    return labels.unpublished;
  }

  if (wasAutoPublished) {
    return labels.autoPublished;
  }

  return labels.published;
}
